import { render, staticRenderFns } from "./SidebarWidget.vue?vue&type=template&id=aaa158f0&"
import script from "./SidebarWidget.vue?vue&type=script&lang=js&"
export * from "./SidebarWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaa158f0')) {
      api.createRecord('aaa158f0', component.options)
    } else {
      api.reload('aaa158f0', component.options)
    }
    module.hot.accept("./SidebarWidget.vue?vue&type=template&id=aaa158f0&", function () {
      api.rerender('aaa158f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/SidebarWidget.vue"
export default component.exports